// Module
var code = "<!-- ko if: component() -->\n<div id=\"tooltip\" class=\"tooltip bubble\" data-bind=\"css: getPosition(), visible: visible\">\n    <div class=\"tooltip-inner\" data-bind=\"component: { name: component(), params: params() }\"></div>\n</div>\n<!-- /ko -->";
// Exports
module.exports = code;